import  { useContext } from 'react';
import BioContext from '../../store/bio-context';
import ThemeContext from '../../store/theme-context';
import landingPageImage from '../../Images/home/landing.svg';
import Button from '../UI/Button';
import { useNavigate } from 'react-router-dom';


const Introduction = () => {
    const navigate = useNavigate();
    const profileInfo = useContext(BioContext);
    const theme = useContext(ThemeContext);

    const workButtonHandler = (e)=>{
        e.preventDefault();
        navigate('/projects');
    }
    return ( 
        <section className="introduction" style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
            <div>
                <p>HEY THERE</p>
                <h1 style={{textShadow: "2px 2px 5px gray"}}>I AM {profileInfo.GeneralInfo.name.toUpperCase()}</h1>
                <p>{profileInfo.GeneralInfo.designation}</p>
                <Button onClick={workButtonHandler} buttonTitle="VIEW MY WORK"/>
                
            </div>
            <div>
                <img src={landingPageImage} alt="landing page image" className="landingPageImage"/>
            </div>
        </section>
        
     );
}
 
export default Introduction;